export const DOCUMENT_UPLOAD_ACCEPTED_IMAGE_TYPES = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpeg', '.jpg'],
} as const;

export const DOCUMENT_UPLOAD_ACCEPTED_TYPES = {
  'application/pdf': ['.pdf'],
  ...DOCUMENT_UPLOAD_ACCEPTED_IMAGE_TYPES,
} as const;

export const MIN_DOCUMENT_TITLE_LENGTH = 6;
